import { useState, useEffect } from "react";
import { getUserPaymentDetails } from "../../services/userService";
import PaymentPlanTable from "./PaymentPlanTable";
import { CenteredLoader } from "../shared/CenteredLoader";
import useMobile from "../../hooks/useOrientation";
import { getCurrencySymbol } from "../../helpers/currency";

export const PassengerTripDetails = ({ passenger, setFinishedLoading }) => {
  const [data, setData] = useState();
  const { documentId, isActive, currency } = passenger;

  useEffect(() => {
    getUserPaymentDetails(documentId).then((res) => {
      setData(res);
      setFinishedLoading(true);
    });
  }, []);

  if (!data) return <CenteredLoader />;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 16,
        marginBottom: 8,
      }}
    >
      {!isActive && (
        <div style={styles.warningBanner}>
          ⚠️ Atención: el pasajero ha sido dado de baja del viaje.
        </div>
      )}
      <TripSummary data={{ ...data, isActive }} currency={currency} />
      {data.totalPendingToPay > 0 && (
        <PaymentPlanTable payments={data.payments} currency={currency} />
      )}
    </div>
  );
};

const TripSummary = ({ data, currency }) => {
  const isMobile = useMobile();
  const currencySymbol = getCurrencySymbol(currency);

  const items = [
    { label: "Pasajero", value: data.userName, highlight: false },
    { label: "Viaje", value: data.tripName, highlight: false },
    {
      label: "Precio total",
      value: data.totalPrice + " " + currencySymbol,
      highlight: false,
    },
    {
      label: "Saldo",
      value:
        data.totalPendingToPay > 0
          ? `${data.totalPendingToPay} ${currencySymbol} pendientes`
          : "Plan de pagos completado.",
      highlight: true,
    },
  ];

  const saldo =
    data.totalPendingToPay > 0
      ? `${data.totalPendingToPay} ${currencySymbol} pendientes`
      : "Plan de pagos completado.";

  return (
    <div style={styles.card}>
      <div
        style={{
          ...styles.grid,
          gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
        }}
      >
        {items.map(({ label, value, highlight }, i) => (
          <div
            key={label}
            style={{
              ...styles.cell,
              ...(isMobile ? styles.cellMobileBorder : getCellBorder(i)),
            }}
          >
            <span style={styles.cellLabel}>{label}</span>
            <span
              style={{
                ...styles.cellValue,
                ...(highlight ? styles.highlight : {}),
              }}
            >
              {value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

// helpers for desktop border pattern (2-col grid)
const getCellBorder = (i) => {
  const isLeftCol = i % 2 === 0;
  const isLastPair = i >= 2; // last row before saldo
  return {
    borderRight: isLeftCol ? "1px solid #f0f0f0" : "none",
    borderBottom: !isLastPair ? "1px solid #f0f0f0" : "none",
    paddingRight: 20,
    paddingLeft: 20,
  };
};

const styles = {
  card: {
    border: "1.5px solid #e0e0e0",
    borderRadius: 12,
    overflow: "hidden",
  },
  grid: {
    display: "grid",
  },
  cell: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
    padding: "14px 20px",
  },
  cellMobileBorder: {
    borderBottom: "1px solid #f0f0f0",
    padding: "16px 24px",
  },
  cellLabel: {
    fontSize: 13,
    color: "#888",
  },
  cellValue: {
    fontSize: 13,
    fontWeight: 600,
    color: "#111",
  },
  highlight: {
    color: "#00a896",
  },
  saldoRow: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
    padding: "14px 20px",
    borderTop: "1px solid #f0f0f0",
  },
  warningBanner: {
    background: "#fff4e5",
    border: "1px solid #f5a623",
    borderRadius: 8,
    padding: "10px 16px",
    color: "#7a4f00",
    fontSize: 12,
  },
};
